import { configureStore } from "@reduxjs/toolkit";
import { injectStore } from "../api";
import authSlice from "./slices/auth/slice";
import subscriptionSlice from "./slices/subscription/slice";
import userSlice from "./slices/user/slice";
import modelSlice from "./slices/model/slice";
import commonSlice from "./slices/common/slice";
import paymentSlice from "./slices/payment/slice";

const store = configureStore({
  reducer: {
    authInfo: authSlice,
    subscriptionInfo: subscriptionSlice,
    paymentInfo: paymentSlice,
    userInfo: userSlice,
    modelInfo: modelSlice,
    commonInfo: commonSlice,
  },
  devTools: false,
});

injectStore(store);

export default store;
